function splitObjectTypeWords(objectType: string): string {
  return objectType.replace(/([A-Z])/g, ' $1').trim();
}

export function getTitleCasedObjectTypeLabel(objectType: string): string {
  const words = splitObjectTypeWords(objectType);
  if (words === '') {
    return '';
  }
  return `${words.charAt(0).toUpperCase()}${words.slice(1)}`;
}

export function getLowerCasedObjectTypeLabel(objectType: string): string {
  return splitObjectTypeWords(objectType).toLowerCase();
}

export function withIndefiniteArticle(noun: string): string {
  return /^[aeiou]/i.test(noun) ? `an ${noun}` : `a ${noun}`;
}
